(() => {
  'use strict';
  const wrap = document.querySelector('.rezw');
  if (!wrap) return;
  const btn = wrap.querySelector('.rez-t');
  const menu = wrap.querySelector('.rezm');
  if (!btn || !menu) return;
  // Przełącznik jest linkiem do /pages/rezerwacja (zapas bez JS). Tu robimy z niego przycisk.
  if (btn.tagName === 'A') btn.setAttribute('role', 'button');
  const open = state => {
    menu.hidden = !state;
    btn.setAttribute('aria-expanded', state ? 'true' : 'false');
  };
  btn.addEventListener('click', event => { event.preventDefault(); open(menu.hidden); });
  btn.addEventListener('keydown', event => {
    if (event.key === ' ' || event.key === 'Spacebar') { event.preventDefault(); open(menu.hidden); }
  });
  document.addEventListener('click', event => { if (!wrap.contains(event.target)) open(false); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !menu.hidden) { open(false); btn.focus(); }
  });
  // Tab poza listę zamyka ją, żeby nie wisiała nad treścią, do której przeszedł fokus.
  wrap.addEventListener('focusout', event => {
    if (event.relatedTarget && !wrap.contains(event.relatedTarget)) open(false);
  });
  // Wybór z tej listy to świadoma decyzja gościa — tylko taką zapamiętujemy dla paska na dole.
  menu.addEventListener('click', event => {
    const link = event.target.closest('a[data-venue]');
    if (!link) return;
    try { localStorage.setItem('orzo.preferredVenue', link.dataset.venue); } catch (_) {}
  });
})();

/* Wybór lokalu w oknie (Projektant, 09.10.2026). Każdy link do /pages/rezerwacja otwiera
   okno z pięcioma restauracjami i linkami prosto do MojStolik. Na samej stronie rezerwacji,
   przy kliknięciu z Ctrl/Cmd albo bez obsługi <dialog> link działa jak zwykle. */
(() => {
  'use strict';
  const d = document.getElementById('rezd');
  if (!d || typeof d.showModal !== 'function') return;
  const cel = /^(\/[a-z]{2}(-[a-z]{2})?)?\/pages\/rezerwacja\/?$/i;
  if (cel.test(location.pathname)) return;
  document.addEventListener('click', e => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href]');
    if (!a || a.closest('#rezd') || a.target === '_blank') return;
    let u;
    try { u = new URL(a.href, location.href); } catch (_) { return; }
    if (u.origin !== location.origin || !cel.test(u.pathname)) return;
    e.preventDefault();
    d.showModal();
    const dane = { strona: location.pathname, skad: (a.textContent || '').trim().slice(0, 60) };
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('orzo_rezerwacja_wybor', dane); } catch (_) {}
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'orzo_rezerwacja_wybor' }, dane));
  });
  /* klik w tło zamyka okno */
  d.addEventListener('click', e => {
    if (e.target === d) { d.close(); return; }
    const link = e.target.closest('a[data-venue]');
    if (link) { try { localStorage.setItem('orzo.preferredVenue', link.dataset.venue); } catch (_) {} }
  });
})();
